import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ProjectCommunicationService } from '../communication/project-comms.service';
import { ConfiguredToastrService } from '../helper/toastr/configured-toastr.service';
import { AnessaTranslationService } from '../helper/translation/anessa-translation.service';

@Injectable({
  providedIn: 'root'
})
export class ScenarioComparisonResultsGuard {
  constructor(private projectCommService: ProjectCommunicationService,
              private router: Router,
              private toastrService: ConfiguredToastrService,
              public translationService: AnessaTranslationService
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.projectCommService.getProjectLoaded()) {
      const scenarioComparison = this.projectCommService.getScenarioComparison();
      if (scenarioComparison?.scenarios && scenarioComparison.scenarios.length > 0) {
        return true;
      } else {
        this.toastrService.warning(this.translationService.get('SCENARIO_COMPARISON.RESULTS.ADD_SCENARIOS'));
        this.router.navigateByUrl('/results/sensitivity/scenario');
        return false;
      }
    }
    return true;
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    if (this.projectCommService.getProjectLoaded()) {
      const scenarioComparison = this.projectCommService.getScenarioComparison();
      if (scenarioComparison?.scenarios && scenarioComparison?.scenarios.length > 0) {
        return true;
      } else {
        this.toastrService.warning(this.translationService.get('SCENARIO_COMPARISON.RESULTS.ADD_SCENARIOS'));
        this.router.navigateByUrl('/results/sensitivity/scenario');
        return false;
      }
    }
    return true;
  }
}
